import { render } from "./ModalPaymentDeliveryMan.vue?vue&type=template&id=6a6f20d3"
import script from "./ModalPaymentDeliveryMan.vue?vue&type=script&lang=js"
export * from "./ModalPaymentDeliveryMan.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__